import React from "react";
import * as Yup from "yup";

import "utils/yup-validation";
import RemoveSourceDocumentForm from "./form";

/**
 * Container component that sets up schema and props for RemoveSourceDocumentForm
 */
export default ({ orgUnitId, referralId, sourceDocumentId, onSucceed }) => {
  // Define validation schema for the form
  const schema = Yup.object().shape({
    deletion: Yup.object().shape({
      reason: Yup.string()
        .trim()
        .required("Reason for Removal is required")
        .max(500, "Reason for Removal exceeds maximum length of 500 characters")
        .default(""),
    }),
  });

  // Props for the form content header
  const contentProps = {
    title: "Remove Referral Source Document",
  };

  return (
    <RemoveSourceDocumentForm
      schema={schema}
      orgUnitId={orgUnitId}
      referralId={referralId}
      sourceDocumentId={sourceDocumentId}
      onSucceed={onSucceed}
      contentProps={contentProps}
    />
  );
};
